var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_249_1558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.0688 54.2736H54.1351C52.7957 66.486 45.2319 76.8074 34.6741 82.0469C34.5559 89.1774 28.1346 94.7714 20.689 93.4714C15.9616 92.6441 12.0616 88.744 11.2343 84.0167C9.89485 76.5317 15.6071 70.0315 22.8557 70.0315C26.5982 70.0315 29.868 71.8043 32.0347 74.5225C39.5197 70.4649 44.8773 63.0587 46.138 54.2736H33.9256C32.0347 59.5525 26.5982 63.0981 20.4526 61.9162C15.8041 61.0101 12.0616 57.1889 11.1949 52.5403C9.85545 45.0553 15.6071 38.5158 22.8557 38.5158C27.977 38.5158 32.3104 41.8249 33.965 46.3947H46.1774C44.9167 37.6097 39.5197 30.2429 32.0347 26.1458C29.5134 29.2974 25.4558 31.1884 20.9648 30.4792C16.1192 29.7307 12.0616 25.7913 11.2343 20.9457C9.93424 13.5001 15.6465 7 22.8557 7C29.3164 7 34.5165 12.1607 34.6347 18.6214C45.1925 23.8609 52.7563 34.1823 54.0957 46.3947H74.0688V39.3431C74.0688 37.5703 76.1961 36.7036 77.4174 37.9642L88.4085 48.9554C89.1964 49.7433 89.1964 50.9645 88.4085 51.7524L77.4174 62.7435C76.1961 63.9647 74.0688 63.0981 74.0688 61.3253V54.2736Z",
    fill: "#F84343"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_249_1558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediation);
export default __webpack_public_path__ + "static/media/mediation.8d226e4deb32256168cab6ec6c59036f.svg";
export { ForwardRef as ReactComponent };